module.exports = __webpack_public_path__ + "img/pets.7bfe6652.png";